module.exports = __webpack_public_path__ + "img/about.19bfd4d5.jpg";